import { COMMISSIONS_POLICIES_ADD_OPPORTUNITY } from '../constants'

export function reducer(state, action) {
  if (action.type === COMMISSIONS_POLICIES_ADD_OPPORTUNITY) {
    return {
      ...state,
      policies: {
        ...state.policies,
        opportunityIncentiveProduct: action.data
      }
    }
  } else {
    return state
  }
}
